import { Component, ViewChild } from "@angular/core";
import { IonicPage, NavController, NavParams, ModalController, AlertController, LoadingController, ToastController } from "ionic-angular";

import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import { PatientDetailsPage } from "../patient-details/patient-details";
import { PatientAddPage } from "../patient-add/patient-add";
import {ENV} from '@app/env'
import { Subject } from 'rxjs/Subject';
import { PatientBatchPage } from "../patient-batch/patient-batch";
import { Storage } from "@ionic/storage";
import { PatientUploadPage } from "../patient-upload/patient-upload";
import { UtilityProvider } from "../../providers/utility/utility";
import algoliasearch, {SearchIndex} from "algoliasearch/lite";
import { forkJoin, Observable } from "rxjs";
import { PdfRxProvider } from "../../providers/pdf/pdf_rx";
import { Rx } from "models/rx";
import { take } from "rxjs/operators";
import moment from "moment";

@IonicPage()
@Component({
  selector: "page-patients",
  templateUrl: "patients.html"
})
export class PatientsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  @ViewChild('myTable') table: any;

  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  user: any;
  email: any;
  public clinic: any = {};
  clinic_order_number: string;

  searchTerm: string = "";

  searchClient = algoliasearch("IC16S8E978", "9d4fcf7bc58da33324e8893edecb125a");
  patientIndex: SearchIndex;
  nextPage: number = 1;
  totalPages: number;

  isLoading = false;
  rows: any[] = [];

  count$: Observable<number>

  patientEditCallback = (_patientdata) => {
    return new Promise<void>((resolve) => {
      console.log(_patientdata);
      for (let i in this.rows) {
        if (this.rows[i].id === _patientdata.id) {
          Object.assign(this.rows[i], _patientdata);
          this.rows = [...this.rows];
          break;
        }
      }
      resolve();
    });
  };

  patientAddCallback = (_patientdata) => {
    return new Promise<void>((resolve) => {
      console.log('Add Patient: ', _patientdata);
      for (let i in this.rows) {
        if (this.rows[i].last_name.toLowerCase() > _patientdata.last_name.toLowerCase()) {
          this.rows.splice(Number(i), 0, _patientdata);
          this.rows = [...this.rows];
          break;
        }
      }
      resolve();
    });
  };

  patientDeleteCallback = (_patient_id) => {
    console.log(this.rows);
    console.log(this);
    return new Promise<void>((resolve) => {
      for (let i in this.rows) {
        if (this.rows[i].id === _patient_id) {
          console.log("ere");
          this.rows.splice(Number(i), 1)
          this.rows = [...this.rows];
        }
      }
      resolve()
    });
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    private modalCtrl: ModalController,
    private storage: Storage,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    public utility: UtilityProvider,
    private pdfRx: PdfRxProvider,
    private toastCtrl: ToastController
  ) {
    this.auth.user
    .takeUntil(this.ngUnsubscribe)
    .subscribe(user => {
      this.user = user;
      this.email = user.email;
      console.log("User email: ", this.email);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;
      this.database.getClinic(this.clinic_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
          this.clinic_order_number = 'ORD' + this.utility.pad(this.clinic.current_order, 5, '0');
        }
      });

      let environment = ENV.ALGOLIA_PREFIX;
      console.log('Env: ', environment);
      this.patientIndex = this.searchClient.initIndex(environment + this.clinic_id);

      this.isLoading = true;
      this.patientIndex.search('')
        .then((result) => {
          this.totalPages = result.nbPages;
          this.rows = result.hits;
          this.isLoading = false;
          console.log(this.rows.length)
        })
        .catch(err => console.log(err))
    });


  }

  ngOnDestroy() {
    console.log('Leave patient and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  goPatient() {
    this.navCtrl.push(PatientAddPage, {addCallback: this.patientAddCallback});
  }
  
  showPatientDetail(patient) {
    this.navCtrl.push(PatientDetailsPage,
      {patient: patient, editCallback: this.patientEditCallback, deleteCallback: this.patientDeleteCallback})
  }

  editPatient(patient) {
    this.navCtrl.push(PatientAddPage, {patient: patient, editCallback: this.patientEditCallback})
  }

  updateFilter() {
    this.isLoading = true;
    this.patientIndex.search(this.searchTerm).then((result) => {
      console.log(result);
      this.nextPage = 1;
      this.totalPages = result.nbPages;
      this.rows = result.hits;

      this.isLoading = false;
    })
  }

  formatdate(date)  {
    return this.utility.formatDate(date, "YYYY MMM DD");
  }
  
  async addRxtoBatch(patient, isReorder: boolean) {
    if (!isReorder) {
      this.navCtrl.push(PatientBatchPage, { 'patientdata': patient });
    }
    else {
      const currentPatientBatchCount = await this.database.getOrdersByPatientBatchedCount(this.clinic_id, patient.id);
      let message = '';
      const currentPatientLastFilledRx = await this.database.getPrescriptionsByPatientFilledCount(this.clinic_id, patient.id);
      if (currentPatientLastFilledRx.length === 1) {
        if (moment().add(-1, 'month').isBefore(currentPatientLastFilledRx[0]['filled_date'].toDate())) {
          message += `<b style='background-color: red; border-radius: 4px; color: white; font-weight: bold;'>Warning: A prescription for this patient was filled in the last month in Order: ${currentPatientLastFilledRx[0]['order_number']}</b><br/><br/>`;
        }
      }
      if (currentPatientBatchCount > 0) {
        message += "<b style='color: red; font-weight: bold;'>Warning: there is already an rx for this patient in this order.  Would you still like to add this Rx?</b>";
      } else {
        message += "Are you sure you would like to re-order?";
      }
      if(patient.last_rx.note)  {
        message += "<br><br>Last Note: " + patient.last_rx.note;
      }
      let confirm = this.alertCtrl.create({
        title: "Re-Order",
        cssClass: "patient-batch-alert",
        message:
          message,
          inputs: [
            {
              name: 'note',
              id: "reorder-note",
              placeholder: 'Enter a note (not mandatory)',
              value: patient.last_rx.note
            },
          ],
        buttons: [
          {
            text: "No",
            handler: () => {}
          },
          {
            text: "Yes",
            handler: (data) => {
              this.reOrderLastRx(patient, this.clinic_id, this.clinic_name, data.note);
            }
          }
        ]
      });
      confirm.present().then(() => (<HTMLInputElement>document.getElementById("reorder-note")).select());
    }
  }

  uploadPatients()  {
    let uploadModal = this.modalCtrl.create(PatientUploadPage, null, {showBackdrop: true, enableBackdropDismiss: false});
    uploadModal.present();
  }

  resetPatients() {
    console.log('Reset patients button clicked');
  }

  onScroll(scrollEvent: any) {
    if (scrollEvent.target && this.nextPage < this.totalPages && !this.isLoading &&
      scrollEvent.target.scrollTop + scrollEvent.target.clientHeight >= scrollEvent.target.scrollHeight)
    {
      console.log("end");
      this.patientIndex.search(this.searchTerm, {page: this.nextPage}).then((result) => {
        console.log(result);
        this.rows = [...this.rows, ...result.hits];
        this.nextPage++;
      })
    }
  }

  checkDob(patient: any)  {
    const dobIsCorrect = this.utility.isPatientDOBCorrect(patient);
    if (!dobIsCorrect)  {
      return true; //console.log(`${patient.last_name} - dob correct: ${dobIsCorrect}`);
    } else {
      return false;
    }
  }


  public reOrderLastRx(patient, clinic_id, clinic_name, note) {
    let loading = this.loadingCtrl.create({});
    loading.present();
    //temporary patch to make primary_location.name == clinic_name
    if (patient.last_rx.location.name === "Primary Location") patient.last_rx.location.name = clinic_name;
    forkJoin(
      [
        this.utility.getNursingHomeId(patient.last_rx),
        this.database.getDoc(`clinics/${clinic_id}/doctors/`, patient.last_rx.doctor.id).get().take(1),
        this.database.getDoc(`clinics/${clinic_id}/patients/${patient.id}/prescriptions/`, patient.last_rx.rx_id).get().take(1)
        // this.database.getDoc(`prescriptions/`, patient.last_rx.rx_id).get().take(1)
      ]
    ).pipe(take(1)).subscribe(async ([nursingHomeId, doctor, rxSnapshot]) => {
      const doc = doctor.data();
      const rx = rxSnapshot.data();
      //fix old DIN for Eylea PFS
      if (rx.medication_name === 'Eylea PFS')  {
        rx.medication[0].din = '02505355';
      }
      //temporary while Lucentis medication type is still in circulation
      if (rx.medication === "Lucentis")
        rx.medication = "Lucentis PFS";
      if (rx.location.name === "Primary Location")
        rx.location.name = clinic_name;

      if (note) {
        rx.note = note;
      } else {
        rx.note = null;
      }

      rx.nursing_home_id = nursingHomeId;
      rx.injectiondate = null;

      rx.rx_id = this.database.createId();
      rx.patient = JSON.parse(JSON.stringify(patient));
      delete rx.patient._highlightResult;
      delete rx.patient.last_rx;
      if (rx.patient.phone_number )  {
        rx.patient.phone_number_primary = rx.patient.phone_number
      }
      rx.doctor = doc;
      rx.doctor.id = patient.last_rx.doctor.id;
      rx.doctor_id = patient.last_rx.doctor.id;
      rx.createdAt = Date.now();
      rx.updatedAt = rx.createdAt;
      rx.clinic_id = this.clinic_id;
      rx.clinic_name = this.clinic_name;
      rx.clinic_province = this.clinic_province;
      rx.filled = false;
      rx.injectiondate = null;
      rx.order_number_clinic = this.clinic_order_number;
      rx.patient_id = patient.id;
      rx.medication_name = rx.medication;
      rx.status = "Batch";
      rx.software_version = ENV.VERSION;
      if (rx.eye === 'OD' || rx.eye === 'OS') {
        rx.quantity_numeric = 1;
      } else {
        rx.quantity_numeric = 2;
      }

      rx.medication = [
        {
          category: null,
          createdAt: null,
          din: this.database.dins[rx.medication],
          name: rx.medication
        }
      ];

      rx.createdBy = this.email;

      if (rx.tobra) {
        rx.medication.push({category: null, createdAt: null, din: "02241755", name: "Tobramycin"})
      }
      
      const rxUrl = await this.pdfRx.createRxPDF(rx);
      rx.prescription_image = {
        path: `prescriptions/${rx.clinic_name}_${rx.patient.last_name}_${rx.createdAt}.pdf`,
        type: 'pdf',
        url: rxUrl
      }
      console.log('New Rx: ', rx);
      console.log(patient);

      return this.database.setDocWithExistingID('prescriptions', rx.rx_id, rx).then(() => {
        loading.dismiss();
      }).catch(() => {
        loading.dismiss();
        this.toastCtrl.create({
          message: "There was a problem creating this prescription from the patients last order.  Please use the Add Rx option instead.",
          duration: 4000,
          position: 'middle'
        }).present()
      })
    },
    (err) => {
      this.toastCtrl.create({
        message: "There was a problem creating this prescription from the patients last order.  Please use the Add Rx option instead.",
        duration: 4000,
        position: 'middle'
      }).present()
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.ts